module.exports = __webpack_public_path__ + "static/elfego-gomez-8e9a3d2ab542d19179322b0c54f7f4dc.jpg";